import {isNil} from 'lodash';

export function setStorage(key, data, ttl){
    const now = new Date();
    //var ttl = 60; // 1 minute
    var dataWithExpiryTime = {
        value: data,
        expiry: now.getTime()+ttl
    }
    window.localStorage.setItem(key, JSON.stringify(dataWithExpiryTime));
    //window.localStorage.setItem(key+"_expiry", now.getTime()+ttl);
    /*if(isJSONstring(data)){
        window.localStorage.setItem(key, JSON.stringify(data));
    }else{
        window.localStorage.setItem(key, data);
    }*/
    
}

export function getStorage(key){
    const now = new Date();
    
    var data = window.localStorage.getItem(key);
    //var data_expiry = window.localStorage.getItem(key+"_expiry");
    //console.log(data);
    if(!isNil(data)){
        var item = JSON.parse(data);
        //console.log(item.expiry);
        //console.log(now.getTime());
        //console.log(item.expiry > now.getTime());
        if(now.getTime() < item.expiry){
            return item.value;
        }else{
            removeStorage(key);
            return false;
        }
       /* if(isJSONstring(data)){
            return JSON.parse(data);
        }else{
            return data;
        }*/
    }else{
        return false;
    }
}

// remove storage key
export function removeStorage(key){
    window.localStorage.removeItem(key);
}

// clear all local storage data
export function clearStorage(){
    window.localStorage.clear();
}

// check storage expire date
export function checkStorage(key){

}

export function customStorageReturnValue(key, changedValue, ttl){
    var data = getStorage(key);
    if(data){
        return data;
    }else{
        setStorage(key, changedValue, ttl);
        return changedValue;
    }
}
export function isJSONstring(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function isJSON(text) {
    if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
            return true;
    }else{
            return false;
    }
}

